import { render, staticRenderFns } from "./MB100.vue?vue&type=template&id=2615b222&"
import script from "./MB100.vue?vue&type=script&lang=js&"
export * from "./MB100.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports